import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getFilteredFields.success: {
            return { ...action.payload.results, next: action.payload.next };
        }

        default:
            return state;
    }
}
